import * as constant from '../constants/ActionTypes';
import { chatType } from '../constants/UtilVariables';

function login(currentUri) {
  window.open(`/signin/?returnUri=${currentUri}`, '_self');
  return {
    type: constant.LOGIN_SIGNIN_REDIRECT,
    payload: currentUri,
  };
}

function dispatchCallUs(currentUri) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_CALLUS,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}
function dispatchEmailUs(currentUri) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_EMAIL,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

function dispatchEmailUsNoIntent(currentUri) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_EMAIL_NO_INTENT,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

function dispatchChatBotChannel(currentUri, topic) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_CHAT_BOT,
      payload: topic,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}

function dispatchLiveChatChannel(currentUri, topic) {
  return (dispatch) => {
    dispatch({
      type: constant.LOGIN_LIVE_CHAT,
      payload: topic,
    });
    setTimeout(() => {
      dispatch(login(currentUri));
    }, 100);
  };
}
function dispatchLogin(currentUri, channel, topic = {}) {
  if (channel === 'callUs') {
    return dispatchCallUs(currentUri);
  } else if (channel === 'email') {
    return dispatchEmailUsNoIntent(currentUri);
  } else if (channel === chatType.chatBot) {
    return dispatchChatBotChannel(currentUri, topic);
  } else if (channel === chatType.liveChat) {
    return dispatchLiveChatChannel(currentUri, topic);
  }

  return dispatchEmailUs(currentUri);
}

module.exports = {
  dispatchLogin,
};
